import styled, { useTheme } from 'styled-components';
import Modal, { FullHeightModalContent } from '../../../components/Modal';
import { ParagraphLargeText } from '../../../components/Texts';
import Steps from '../../../components/Steps';
import { useGiftFlow } from '../../../components/GiftFlow';
import { useGiftForm } from '../../../components/GiftFormContext';
import { useEffect } from 'react';

const TitleAndStepsContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

const GiftFlowModal = ({ onClose, initialStep = 0, tokenAddress, network }) => {
  const theme = useTheme();
  const { initializeForm, targetTokenAddress, network: formNetwork } = useGiftForm();

  // Initialize form with token if provided via props (but not already set)
  useEffect(() => {
    if (tokenAddress && network && (!targetTokenAddress || !formNetwork)) {
      initializeForm({
        initialValues: {
          targetTokenAddress: tokenAddress,
          network: network,
        },
      });
    }
  }, [tokenAddress, network, initializeForm, targetTokenAddress, formNetwork]);

  // Calculate initial step: if token is provided via props, skip to step 1
  // Don't check form state - we only want to skip on initial load with props
  const calculatedInitialStep = initialStep !== 0
    ? initialStep
    : (tokenAddress && network ? 1 : 0);

  const {
    currentStep,
    totalSteps,
    currentTitle,
    Component,
    handleStepChange,
    onBack,
    shouldShowBackButton,
    buttonLabel,
  } = useGiftFlow(calculatedInitialStep);

  return (
    <Modal
      onClose={onClose}
      onBack={shouldShowBackButton ? onBack : undefined}
    >
      <FullHeightModalContent>
        <TitleAndStepsContainer>
          <ParagraphLargeText
            style={{ textAlign: 'center', color: theme.text.title }}
          >
            {currentTitle}
          </ParagraphLargeText>
          <Steps steps={totalSteps} currentStep={currentStep} />
        </TitleAndStepsContainer>
        <Component
          isModal={true}
          currentStep={currentStep}
          onContinue={() => {
            handleStepChange(currentStep + 1);
          }}
          buttonLabel={buttonLabel}
        />
      </FullHeightModalContent>
    </Modal>
  );
};

export default GiftFlowModal;
